module.exports = __webpack_public_path__ + "static/media/rating.d890fb80.svg";